/**
 * PATH: packages/tenant-shared/src/auth/authV2CookieRefreshDead.ts
 * FILE_ID: TENANTSHARED-AUTH-AUTHV2-COOKIE-REFRESH-DEAD-001
 * PURPOSE: Twin latch for quotechApi silent refresh (no @quotech/auth dep).
 * NOTES FOR FUTURE AI: Key MUST match auth + ui twins exactly.
 */

/** MUST match packages/auth/.../authV2CookieRefreshDead.ts exactly. */
export const AUTHV2_COOKIE_REFRESH_DEAD_KEY = 'quotech_authv2_cookie_refresh_dead'

export function markAuthV2CookieRefreshDead(): void {
  if (typeof localStorage === 'undefined') return
  try {
    localStorage.setItem(AUTHV2_COOKIE_REFRESH_DEAD_KEY, String(Date.now()))
  } catch {
    // private-mode / quota
  }
}

export function isAuthV2CookieRefreshDead(): boolean {
  if (typeof localStorage === 'undefined') return false
  try {
    return localStorage.getItem(AUTHV2_COOKIE_REFRESH_DEAD_KEY) != null
  } catch {
    return false
  }
}

export function clearAuthV2CookieRefreshDead(): void {
  if (typeof localStorage === 'undefined') return
  try {
    localStorage.removeItem(AUTHV2_COOKIE_REFRESH_DEAD_KEY)
  } catch {
    // ignore
  }
}
